import gql from 'graphql-tag';
import {
  COMMAND_LAUNCH_DEVICE_SIGNATURE_FIELD,
  CORE_CHANGEOVER_FIELDS,
  CORE_COMMAND_LAUNCH_FIELDS,
  CORE_DEVICE_SIGNATURE_FIELDS,
  CORE_MACHINE_COUNT_TYPE_FIELDS,
  CORE_PHASE_FIELDS,
} from '~/graphql/fragments';
import { apolloClient } from '~/plugins/apollo';

export const state = {
  commandLaunch: {},
  commandLaunchId: 0,
  forceStep1: false,
};

export const getters = {
  getCommandLaunch: (state) => state.commandLaunch,
  getCommandLaunchId: (state) => state.commandLaunchId,
  getForceStep1: (state) => state.forceStep1,
};

export const mutations = {
  commitCommandLaunch(state, data) {
    state.commandLaunch = data;
  },
  commitCommandLaunchId(state, data) {
    state.commandLaunchId = data;
  },
  commitForceStep1(state, data) {
    state.forceStep1 = data;
  },
};

export const actions = {
  /**
   * Fetch command launch
   * @param context
   * @param commandId
   */
  async fetchCommandLaunch(context, commandId) {
    const data = (await apolloClient.query(
      {
        query: gql`
          query FetchCommandLaunch($id: ID!) {
            commandLaunch(id: $id) {
              ...CoreCommandLaunchFields
              ...CommandLaunchDeviceSignatureField
              cl_changeover_expand:changeoverExpand{
                ...CoreChangeoverFields
                phaseExpand {
                  ...CorePhaseFields
                  unitTimeMilliSeconds: unitTimeMilliSeconds
                }
                productionExpand {
                  referenceCycleTimesExpandDistinct {
                    phase
                    machine
                    time
                  }
                }
              }
              cl_machine_expand:machineExpand{
                machine_id: id
                machine_name: name
                machine_count_type:countTypeExpand{
                  mct_name:name
                }
                machine_devices_expand:devicesExpand{
                  device_id: id
                  device_params: params
                }
              }
            }
          }
          ${CORE_COMMAND_LAUNCH_FIELDS}
          ${COMMAND_LAUNCH_DEVICE_SIGNATURE_FIELD}
          ${CORE_DEVICE_SIGNATURE_FIELDS}
          ${CORE_CHANGEOVER_FIELDS}
          ${CORE_PHASE_FIELDS}
          ${CORE_MACHINE_COUNT_TYPE_FIELDS}
        `,
        variables: {
          id: commandId,
        },
      },
    )).data.commandLaunch;
    context.commit('commitCommandLaunch', data);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
